/*
 * newsbot - Keywords section for filter details
 */

import { useFormikContext } from "formik";
import { CollapsibleSection, FilterLayoutClass, FilterTightGridGapClass } from "@/components/filters/_components";
import { TextAreaAutoResize } from "@/components/inputs/input";
import { Select } from "@/components/inputs/select";
import { classNames } from "@utils";

const matchLogicOptions = [
  { label: "Match ANY keyword", value: "ANY" },
  { label: "Match ALL keywords", value: "ALL" },
];

interface KeywordsFormValues {
  keywords: string;
  except_keywords: string;
  match_logic: 'ANY' | 'ALL';
  except_logic: 'ANY' | 'ALL';
}

export const Keywords = () => {
  const { values } = useFormikContext<KeywordsFormValues>();

  return (
    <CollapsibleSection
      defaultOpen={values.keywords?.length > 0 || values.except_keywords?.length > 0}
      title="Keywords"
      subtitle="Match or exclude stories by keywords in headline/summary"
    >
      <div className={classNames("sm:col-span-6", FilterLayoutClass, FilterTightGridGapClass)}>
        <TextAreaAutoResize
          name="keywords"
          label="Match keywords"
          columns={8}
          placeholder="bitcoin, ethereum, crypto"
          tooltip={<p>Comma-separated keywords to match</p>}
        />
        <Select
          name="match_logic"
          label="Match logic"
          columns={4}
          options={matchLogicOptions}
          optionDefaultText="any"
        />
      </div>
      <div className={classNames("sm:col-span-6", FilterLayoutClass, FilterTightGridGapClass)}>
        <TextAreaAutoResize
          name="except_keywords"
          label="Except keywords"
          columns={8}
          placeholder="sponsor, ad, promo"
          tooltip={<p>Stories with these keywords are excluded</p>}
        />
        <Select
          name="except_logic"
          label="Except logic"
          columns={4}
          options={matchLogicOptions}
          optionDefaultText="any"
        />
      </div>
    </CollapsibleSection>
  );
};
